<template>
<div>
  <div v-if="Loaded">

  <p v-show="false">{{Inlogged}}</p>
   <v-card v-if="loggedInmember==true">

           <NewCase    
                      :id="member.id"
                      :schoolId="member.schoolId"
                      :teachernameandId="teachernameandId"
                      :membernameandId="membernameandId"  v-model="dialogcreate" />

                       <Violations
          :schoolId="member.schoolId"
          :id="member.id"
          typ="eht"
          v-model="dialogviolate"
        />
        
  <v-btn @click="send=true" dark class="eraser" >
    Anmäl elevförändring
  </v-btn>
    <!-- <v-btn @click="dialogviolate=true" dark class="eraser" >
    Anmäl Kränkning
  </v-btn> -->
  <SendtoNurse  :schoolId="member.schoolId" As="EHT" :reporter="member.name"    v-model="send" />
<NurseActivity :schoolId="member.schoolId" :person="member"  :role="member.role" Headline="Elevförändring"  ToolColor="light-blue ligthen-1"  />
<Mapping Headline="Kartläggningar"  :schoolId="member.schoolId" ToolColor="green lighten-2" />

<!-- <NurseActivity v-if="member.role=='skolsköterska' ||member.role=='rektor'" :schoolId="member.schoolId"  Headline="Elevaktivitet"  ToolColor="light-blue ligthen-1"  /> -->
 


      <v-card class="mx-auto" max-width="1000" min-width="300">
                          
              <v-toolbar class="pencil" id="penciltip" color="orange darken-1" dark @click="Hide = !Hide">

          <v-toolbar-title>Ärenden</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        <!-- </div> -->

        </v-toolbar>
  <v-expand-transition>
        <div v-if="Hide">
          <v-btn dark large class="b" color="green ligthen-1" @click="dialogcreate = true">
            Skapa ärende
          </v-btn>
           <v-btn dark large class="b" color="yellow ligthen-1" @click="dialogviolate = true">
            Kränkningsanmälan
          </v-btn>
<shouldOwn typ="me" :schoolId="member.schoolId" :id="member.id" Headline="  Förslag på dig som ägare av åtgärd"  ToolColor="orange lighten-1"  />
<smalllist :person="member" typ="EHT"  Headline="Mina ärenden" ToolColor="orange lighten-2" />

<smalllist :person="member" typ="EHT"  Headline="Alla ärenden" ToolColor="orange lighten-3" />

<shouldOwn typ="notme" :schoolId="member.schoolId" :id="member.id" Headline="  Ärenden utan ägare"  ToolColor="orange lighten-4"  />
 <kränkrapport archive="false" :schoolId="member.schoolId" :id="member.id" :role="member.role"   Headline="Kränkningsanmälningar"  ToolColor="yellow lighten-3"/>
 
<smalllist :person="member"  typ="EHT"  Headline="Arkiverade ärenden"  ToolColor="orange darken-2" />
<kränkrapport archive="true" :schoolId="member.schoolId" :id="member.id" :role="member.role"   Headline="Arkiverade kränkningsanmälningar"  ToolColor="yellow darken-3"/>
 
        </div>
  </v-expand-transition>
      </v-card>
 <AP :schoolId="member.schoolId" role="eht" :id="member.id"  Headline="Åtgärdsprogram/Utredning"  ToolColor="pink lighten-2"/>
  <Extra :schoolId="member.schoolId"  role="eht" :id="member.id"  Headline="Extraanpassningar" ToolColor="light-green lighten-3"/>
 <Protokoll :schoolId="member.schoolId" :id="member.id"  Headline="Protokoll"  ToolColor="blue lighten-3"/>


<div v-if="school!=null">
  

 <Whistle :schoolId="member.schoolId" :schoolCode="school.code" role="eht" :id="member.id"  Headline="Visslingar"  ToolColor="purple lighten-3"/>
 <Feeling :schoolId="member.schoolId" :schoolCode="school.code" role="eht" :id="member.id"  Headline="Måendekoll"  ToolColor="red lighten-3"/>
</div>
   </v-card>
  </div>
  <div v-else class="loader text-xs-center">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import shouldOwn from '../components/shouldOwn'
import smalllist from '../components/Case/smalllist'
import AP from '../components/AP/AP'
import Protokoll from '../components/protokoll/Protokoll'
import Whistle from '../components/feelingwhistle/Whistle'
import SendtoNurse from '../components/SendtoNurse'
import Mapping from '../components/Form/Mapping'
import NurseActivity from '../components/NurseActivity'
import NewCase from '../components/Case/NewCase.vue'
import Extra from '../components/extraanpassning/extra.vue'
import Feeling from '../components/feelingwhistle/Feeling'
import Violations from '../components/violationreport/Violations.vue'
import kränkrapport from '../components/violationreport/kränkrapport'
export default {
  components: {
    smalllist,
    shouldOwn,
    SendtoNurse,
    NurseActivity,
    AP,
    Mapping,
    Protokoll,
    NewCase,
    Extra,
    Whistle,
    Feeling,
    Violations,kränkrapport
  },

  
  props: {

  },
  data: () => ({
      loaded:false,
      send:false,
      Hide: false,
      dialogcreate:false,
      dialogviolate:false,

  }),
  computed: {
    
    ...mapGetters('schools', ['school']),
    ...mapGetters("teachers", ["teachernameandId"]),
    // ...mapGetters("ehtmembers", ["nurseActivities"]),
    ...mapGetters('ehtmembers', ['member', 'loggedInmember','membernameandId','membersFetched']),
    ...mapGetters('cases', ['cases', 'casesnames']),
    ...mapGetters('classesAP', ['APs','APsFetched','Protokoll','ProtokollsFetched']),
 Inlogged() {
   
      if (this.loggedInmember && this.loaded==false) {

        // (this.member)
 let user= {uid:this.member.schoolId,id:this.member.id, displayName:this.member.name, As:"EHT"}

      this.setUser(user || null)
    // this.initcases(this.member.schoolId)
    if(this.membersFetched==false)
    this.initEHT(this.member.schoolId)
    this.initteachers(this.member.schoolId)
    this.initschool(this.member.schoolId)
    this.initClasses(this.member.schoolId)
    // this.initMappings(this.member.schoolId)
    // this.initProtokolls(this.member.schoolId)
    // this.initAPs(this.member.schoolId)
    this.loaded=true;
    // if(this.member.role=="skolsköterska" || this.member.role=="rektor")
    // this.NurseActivityGet(this.member.schoolId);
      // this.loaded=true;
      }
      else if(this.loggedInmember==false)
      {
        this.loaded=false;
      }
    },
    Loaded(){
      if (this.member!= null &&  this.loggedInmember) {
        return true;
      }
      return false;
    },
  },
  methods: {

    ...mapActions('ehtmembers', ['initEHT']),
    ...mapActions('teachers', ['initteachers']),
    ...mapActions('schools', ['initschool']),
    ...mapActions(['setUser']),
    // ...mapActions('cases', ['initcases']),
    // ...mapActions('mappings', ['initMappings']),
    ...mapActions('classesAP', ['initClasses']),

  },
  created () {
   
  },
}
</script>
<style>
.loader{
  margin-top: 20vh;
}



</style>
